<!-- components/staff/editStaff.vue -->
<template>
  <el-dialog :title="$t('staff.modifyStaff')" :visible.sync="visible" width="50%" @close="handleClose">
    <el-form ref="form" :model="editStaffInfo" label-width="120px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('staff.name')" prop="username">
            <el-input v-model="editStaffInfo.username" :placeholder="$t('staff.requiredName')" />
          </el-form-item>
          <el-form-item :label="$t('email')" prop="email">
            <el-input v-model="editStaffInfo.email" :placeholder="$t('staff.optionalEmail')" />
          </el-form-item>
          <el-form-item :label="$t('staff.phone')" prop="tel">
            <el-input v-model="editStaffInfo.tel" :placeholder="$t('staff.requiredPhone')" />
          </el-form-item>
          <el-form-item :label="$t('staff.age')" prop="age">
            <el-input v-model="editStaffInfo.age" type="number" :min="0" :max="150" :placeholder="$t('staff.agePlaceholder')" />
          </el-form-item>
          <el-form-item :label="$t('staff.emergencyContact')" prop="emergencyContact">
            <el-input v-model="editStaffInfo.emergencyContact" :placeholder="$t('staff.emergencyContactPlaceholder')" maxlength="50" />
          </el-form-item>
          <el-form-item :label="$t('staff.gender')" prop="sex">
            <el-select v-model="editStaffInfo.sex" :placeholder="$t('staff.requiredGender')" style="width: 100%">
              <el-option value="0" :label="$t('staff.male')" />
              <el-option value="1" :label="$t('staff.female')" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('staff.relCd')" prop="relCd">
            <el-select v-model="editStaffInfo.relCd" :placeholder="$t('staff.relCdPlaceholder')" style="width: 100%">
              <el-option v-for="(item,index) in editStaffInfo.relCds" :key="index" :label="item.name"
                :value="item.statusCd" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('staff.address')" prop="address">
            <el-input v-model="editStaffInfo.address" :placeholder="$t('staff.requiredAddress')" />
          </el-form-item>
          <el-form-item label="户口所在地" prop="huZhuSuoZaiDi">
            <el-input v-model="editStaffInfo.huZhuSuoZaiDi" placeholder="请输入户口所在地" />
          </el-form-item>
          <el-form-item label="合同期限" prop="heTongQiXian">
            <el-date-picker v-model="editStaffInfo.heTongQiXian" type="date" placeholder="选择日期" style="width: 100%" value-format="yyyy-MM-dd" />
          </el-form-item>
        </el-col>
        <el-col :span="12" style="text-align: center">
          <el-image style="width: 200px; height: 150px; border: 1px dashed #ccc;"
            :src="editStaffInfo.photoUrl || '/img/noPhoto.jpg'" fit="cover" />
          <el-upload class="mt-10" :show-file-list="false" :before-upload="beforeUpload" :http-request="uploadImage" action="">
            <el-button size="small" type="primary">
              {{ $t('common.upload') }}
            </el-button>
          </el-upload>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t('staff.cancel') }}</el-button>
      <el-button type="primary" @click="editStaffSubmit">{{ $t('staff.edit') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { modifyStaff } from '@/api/staff/staffApi'
import { getDict } from '../../api/community/communityApi'
import { uploadImage } from '@/api/owner/ownerApi'


export default {
  name: 'EditStaff',
  props: {
    staffInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      editStaffInfo: {
        userId: '',
        username: '',
        email: '',
        tel: '',
        age: undefined,
        emergencyContact: '',
        sex: '',
        address: '',
        photo: '',
        photoUrl: '',
        relCd: '',
        relCds: [],
        branchOrgs: [],
        departmentOrgs: [],
        parentOrgId: '',
        parentOrgName: '',
        parentTwoOrgId: '',
        orgNewName: '',
        orgId: '',
        huZhuSuoZaiDi: '',
        heTongQiXian: ''
      }
    }
  },
  mounted() {
    // 页面加载时预加载岗位字典
    this.getRelCd()
  },
  watch: {
    staffInfo: {
      immediate: true,
      handler(val) {
        if (val) {
          this.editStaffInfo = {
            ...val,
            username: val.name,
            relCds: this.editStaffInfo.relCds // 保留字典数据
          }
        }
      }
    }
  },
  methods: {
    open(row) {
      console.log('打开编辑，员工数据:', row)
      console.log('员工岗位 relCd:', row.relCd, '类型:', typeof row.relCd)

      let _url =  '/img/noPhoto.jpg'
      if(row.urls && row.urls.length > 0){
        _url = row.urls[0]
      }
      // 保存当前的岗位值
      const currentRelCd = String(row.relCd || row.relCdName || '')
      console.log('转换后的 currentRelCd:', currentRelCd)

      this.editStaffInfo = {
        ...row,
        username: row.name,
        photo: _url,
        relCd: currentRelCd,
        relCds: this.editStaffInfo.relCds
      }
      this.editStaffInfo.photoUrl = row.photoUrl || '/img/noPhoto.jpg'

      // 确保字典已加载
      this.getRelCd().then(() => {
        console.log('字典加载完成，当前 relCds:', this.editStaffInfo.relCds)
        console.log('当前要设置的 relCd:', currentRelCd)
        // 查找匹配的选项
        const matched = this.editStaffInfo.relCds.find(item => String(item.statusCd) === currentRelCd)
        console.log('找到匹配的选项:', matched)

        this.visible = true
        this.$nextTick(() => {
          this.editStaffInfo.relCd = currentRelCd
          console.log('设置完成后 editStaffInfo.relCd:', this.editStaffInfo.relCd)
        })
      })
    },
    async getRelCd() {
      try {
        const res = await getDict('u_org_staff_rel', "rel_cd")
        // 直接赋值，确保数据正确响应
        this.$set(this.editStaffInfo, 'relCds', res)
      } catch (error) {
        console.error('获取岗位字典失败:', error)
        this.$message.error('获取岗位字典失败，请检查网络')
      }
    },
    handleClose() {
      this.visible = false
    },
    validateForm() {
      if (!this.editStaffInfo.username) {
        this.$message.error(this.$t('staff.requiredName'))
        return false
      }
      if (!this.editStaffInfo.tel) {
        this.$message.error(this.$t('staff.requiredPhone'))
        return false
      }
      if (this.editStaffInfo.sex === '') {
        this.$message.error(this.$t('staff.requiredGender'))
        return false
      }
      if (!this.editStaffInfo.address) {
        this.$message.error(this.$t('staff.requiredAddress'))
        return false
      }
      return true
    },
    async editStaffSubmit() {
      if (!this.validateForm()) return

      try {
        this.loading = true
        const data = {
          ...this.editStaffInfo,
          name: this.editStaffInfo.username,
          staffId: this.editStaffInfo.userId
        }

        await modifyStaff(data)
        this.visible = false
        this.$message.success(this.$t('common.operationSuccess'))
        this.$emit('success')
        this.handleClose()
      } catch (error) {
        this.$message.error(error.message)
      } finally {
        this.loading = false
      }
    },
    beforeUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error(this.$t('common.jpgOnly'))
      }
      if (!isLt2M) {
        this.$message.error(this.$t('common.sizeLimit'))
      }
      return isJPG && isLt2M
    },
    async uploadImage({ file }) {
      try {
        const res = await uploadImage({ file })
        this.editStaffInfo.photo = res.fileId
        this.editStaffInfo.photoUrl = res.url
        this.$forceUpdate()
      } catch (error) {
        this.$message.error(this.$t('listOwner.upload.failed'))
      }
    },
  }
}
</script>
